import { put, takeEvery } from 'redux-saga/effects';

import { resourceSagaUtils, resourceStoreTypes } from '../core';
import type { ResourceActionCreator, ResourceFailureActionCreator } from '../core/resourceStoreTypes';
import * as actions from './filtersActions';
import { getLastSyncDate } from './filtersSelectors';
import * as filtersTransformers from './filtersTransformers';
import { transformFilterToRequestData, transformResponseToFilters } from './filtersTransformers';
import type { FilterProps } from './filtersTypes';

const mkQcsSyncFiltersConfig = resourceStoreTypes.createTypedQcsSyncResourcesConfigFactory<FilterProps>();

const mkResourceConfig = (
  successAction: ResourceActionCreator<FilterProps>,
  failureAction: ResourceFailureActionCreator,
) =>
  mkQcsSyncFiltersConfig({
    resourceName: 'filter',
    resourceBaseUrl: '/filters',
    getLastSyncDate,

    transformResponseToResources: transformResponseToFilters,
    transformResourceToRequestData: transformFilterToRequestData,
    applyResourceFromCRUDResponse: true,

    successAction,
    failureAction,
  });

export function* filtersDumpUpdater(resources: FilterProps[]) {
  const filters = resources.map(filtersTransformers.transformServerResourceToClientResource);
  yield put(actions.getFiltersSuccess({ resources: filters }, { context: 'BUMP_CHANGE_DUMP' }));
}

export function* filtersNudgeUpdater() {
  yield put(actions.getFilters(undefined, { context: 'BUMP_CHANGE_NUDGE' }));
}

export function* getFiltersActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.getFiltersSuccess, actions.getFiltersFailure);
  yield resourceSagaUtils.takeAndDebounce(
    actions.getFilters,
    resourceSagaUtils.qcsSyncGetResources<FilterProps>,
    resourceConfig,
  );
}

export function* createFilterActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.createFilterSuccess, actions.createFilterFailure);
  yield takeEvery(actions.createFilter.type, resourceSagaUtils.qcsSyncCreateResource<FilterProps>, resourceConfig);
}

export function* updateFilterActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.updateFilterSuccess, actions.updateFilterFailure);
  yield takeEvery(actions.updateFilter.type, resourceSagaUtils.qcsSyncUpdateResource<FilterProps>, resourceConfig);
}

export function* deleteFilterActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.deleteFilterSuccess, actions.deleteFilterFailure);
  yield takeEvery(actions.deleteFilter.type, resourceSagaUtils.qcsSyncDeleteResource<FilterProps>, resourceConfig);
}

export default [
  getFiltersActionWatcher,
  createFilterActionWatcher,
  updateFilterActionWatcher,
  deleteFilterActionWatcher,
];
